// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-number-input {
  display: flex;
  max-width: 120px;
  /* stylelint-disable */
  /* stylelint-enable */
}
.wizard-number-input input::-webkit-outer-spin-button, .wizard-number-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.wizard-number-input input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/NumberFormatSettings/NumberInput/NumberInput.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EAKA,sBAAA;EASA,qBAAA;AAXJ;AAGI;EAEI,wBAAA;EACA,SAAA;AAFR;AAII;EACI,0BAAA;AAFR","sourcesContent":[".wizard-number-input {\n  display: flex;\n  max-width: 120px;\n  /* stylelint-disable */\n  /* stylelint-enable */\n}\n.wizard-number-input input::-webkit-outer-spin-button, .wizard-number-input input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.wizard-number-input input[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
